const formatDate = (timestamp) => {

    let year = timestamp.toString().substring(0,4);
    let month = timestamp.toString().substring(5,7);
    const date = timestamp.toString().substring(8,10);

        switch (month){
            case '01':
                month = 'Jan';
                break;
            case '02':
                month = 'Feb';
                break;
            case '03':
                month = 'Mar';
                break;
            case '04':
                month = 'Apr';
                break;
            case '05':
                month = 'May';
                break;
            case '06':
                month = 'Jun';
                break;
            case '07':
                month = 'Jul';
                break;
            case '08':
                month = 'Aug';
                break;
            case '09':
                month = 'Sep';
                break;
            case '10':
                month = 'Oct';
                break;
            case '11':
                month = 'Nov';
                break; 
            case '12':
                month = 'Dec';
                break;
                default:   
            month = month
        };

    return `${month}${" "}${date},${" "}${year}`
            
};

const formatTime = (timestamp) => {

    function filterInt(value) {
        if (/^[-+]?(\d+|Infinity)$/.test(value)) {
          return Number(value)
        } else {
          return NaN
        }
    }

    let hour = timestamp.toString().substring(11,13);
    const minute = timestamp.toString().substring(14,16);

    const amPm = hour >= 12 ? 'pm' : 'am';

    hour = filterInt(hour) % 12 || 12;

    return `${hour}:${minute}${amPm}`

}

export { formatDate, formatTime };